import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {ImageOpPerPixelFn} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/image-op-per-pixel-fn/node"
import {WebGl2ImageAtlas} from "@cm/webgl2"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/show-tiles/definition"
import {HalCompositorInfo} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/image-op-per-pixel-fn/hal"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"

@registerNode
export class ImageOpNodeShowTiles extends ImageOpPerPixelFn<typeof definition> {
    static nodeClass = "ImageOpNodeShowTiles"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(parameters)
    }

    protected getCompositingInfo(): HalCompositorInfo {
        return {
            compositingFunction: `
                int tileSize = ${WebGl2ImageAtlas.pageSize};
                float mask, offset;
                const int borderWidth = 2;
                ivec2 pageRelativeIndex = texelIndex % tileSize;
                bool isBorderMin = pageRelativeIndex.x < borderWidth || pageRelativeIndex.y < borderWidth;
                bool isBorderMax = pageRelativeIndex.x >= tileSize - borderWidth || pageRelativeIndex.y >= tileSize - borderWidth;
                if (isBorderMin || isBorderMax) {
                    if (isBorderMin && isBorderMax) {
                        mask = 1.0;
                        offset = 0.0;
                    } else {
                        mask = 0.6;
                        offset = isBorderMin ? 0.2 : 0.0;
                    }
                } else {
                    mask = 1.0;
                    offset = 0.0;
                }
                return fetchSource(0) * mask + offset;
                `,
            sourceParameterNames: ["sourceImage"],
        }
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        // img-proc does nothing
        const {sourceImage} = await evaluator.getAll(parameters)
        sourceImage.addRef()
        return sourceImage
    }
}
